import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import { ContentCopy } from '@mui/icons-material'
import { ReactElement } from 'react'
import DangerousHtml from 'src/components/common/dangerous-html'
import { LegacyTitleScreen } from 'src/v3/core/types'
import { extractPlainText } from 'src/v3/create/v5/course/utils/html-extraction'
import { modalPaperProps } from 'src/v3/utilities/modal-styles'

type Props = {
  isOpen: boolean
  onClose: () => void
  titleScreen: LegacyTitleScreen
}

export default function MigrateTitleScreenModal({
  isOpen,
  onClose,
  titleScreen,
}: Props): ReactElement {
  let handleCopy = () => {
    let plain = extractPlainText(titleScreen.content)
    navigator.clipboard.writeText(plain)
  }

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      slotProps={{
        paper: modalPaperProps,
      }}
      maxWidth="md"
    >
      <DialogTitle>Legacy Title Screen Content</DialogTitle>
      <DialogContent>
        <Typography
          color="text.secondary"
          variant="body2"
          sx={{
            mb: 2,
          }}
        >
          This course has a legacy Title Screen. Copy the content below and
          paste it into the relevant Syllabus fields (Description, Practice Gap,
          etc.) below. Once migrated, this content will no longer appear here.
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 1,
          }}
        >
          <Typography variant="subtitle2">Content</Typography>
          <Button size="small" startIcon={<ContentCopy />} onClick={handleCopy}>
            Copy plain text
          </Button>
        </Box>
        <Box
          sx={{
            p: 2,
            borderRadius: 1,
            bgcolor: 'background.paper',
            maxHeight: 400,
            overflowY: 'auto',
          }}
        >
          <DangerousHtml htmlVal={titleScreen.content} isEncoded={true} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}
